export default {
  communityChannelList: (creatorId: string) => `/patreon/user/${creatorId}/community`,
  communityChannel: (creatorId: string, channelId: string) => `/patreon/user/${creatorId}/community/${channelId}`,
};
